import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { GuaranteedIcon } from 'shared/components/Icons';

import s from './IsGuaranteedElement.css';

const IsGuaranteedElement = ({ type, intl }) =>
  <div
    className={cx(s.root, {
      [s.iconType]: type === 'icon',
      [s.textType]: type === 'text',
      [s.iconWithText]: type === 'iconWithText',
    })}
    title={intl.formatMessage({ id: 'Ассоциация гарантирует' })}
  >
    <GuaranteedIcon />
    {type !== 'icon' && <FormattedMessage id="Ассоциация гарантирует" />}
  </div>;

IsGuaranteedElement.propTypes = {
  intl: PropTypes.shape().isRequired,
  type: PropTypes.string,
};

IsGuaranteedElement.defaultProps = {
  type: 'text',
};
export default withStyles(s)(injectIntl(IsGuaranteedElement));



// WEBPACK FOOTER //
// ./src/shared/components/Elements/IsGuaranteedElement/IsGuaranteedElement.js